module.exports = {
      id: "comm-entertainment-usage",
      viewBox: "0 0 269.757 51.703",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-entertainment",
      toString: function () {
        return this.url;
      }
    }